module.exports = __webpack_public_path__ + "img/p01.68549d03.jpeg";